// const publicRoutes = ['login', 'launcher', 'landing']

export default function(ctx) {
  // Only show registration data to clean up Sentry
  if (
    ctx.env.envName === 'staging' &&
    ctx.query &&
    ctx.query.status &&
    ctx.query.status === 'register'
  ) {
    const data = {
      route: ctx.route.name,
      query: ctx.query,
      params: ctx.params,
      error: ctx.error
      // unifiedApp: window.unifiedApp
    }
    ctx.$sentry.setTag('owner', 'aaltra')
    ctx.$sentry.addBreadcrumb({
      category: 'middleware',
      level: 'info',
      message: 'Staging middleware flow data',
      data: {
        parameters: data
      }
    })
    ctx.$sentry.captureMessage('Middleware data', 'info')
  }
}
